import React, { Fragment, useState, useEffect, useMemo } from 'react';
import { Row, Col, Button, Table } from 'reactstrap';
import moment from 'moment';
import { getTsDate, notify } from '../../../../utils';

import mapping from './stationsMapping';
import ReactTable from '../../../custom/ReactTable';
import ModalEditStations from './ModalEditStations';
import apiClient from '../../../../apiClient';
import _ from 'lodash';
import ModalTimeSelection from './ModalTimeSelection';

const Stations = ({ user, activeTabId, tabId }) => {
    const [corpStationsData, setCorpStationsData] = useState([]);
    const [doors, setDoors] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [modalEditStation, setModalEditStation] = useState(false);
    const [modalTypeNew, setModalTypeNew] = useState(false);
    const [s_dock_door, set_s_dock_door] = useState('');
    const [calloutNotificationNumbers, setCalloutNotificationNumbers] = useState([]);
    const [forklifts, setForklifts] = useState([]);
    const [workDay, setWorkDay] = useState();
    const [modalTimeSelection, setModalTimeSelection] = useState();
    const selectedItem = corpStationsData.find(item => item.id === selectedItemId);

    const stationHoursMap = useMemo(() => {
        if (!selectedItem || !selectedItem.stationHours) return {};
        const map = {};
        const { stationHours } = selectedItem;
        for (const { stationId, day, openHours } of stationHours) {
            map[day] = openHours;
        }
        return map;
    }, [selectedItem]);

    useEffect(() => {
        const selectCorpStationData = () => {
            user &&
                apiClient
                    .get(`/selectCorpStationData`)
                    .then((response) => {
                        const {
                            stations,
                            doors,
                            calloutNotificationNumbers,
                            forklifts
                        } = response.data;
                        setCorpStationsData(stations);
                        setDoors(doors);
                        setCalloutNotificationNumbers(calloutNotificationNumbers);
                        setForklifts(forklifts);
                    })
                    .catch((error) => {});
        };
        if (activeTabId === tabId) {
            selectCorpStationData();
        }
    }, [activeTabId, tabId]);

    const handleStationSelect = (item) => {
        setSelectedItemId(item.id);
        setModalEditStation(true);
        setModalTypeNew(false);
    };

    const updateStationsInfo = (values) => {
        const data = values;
        data.t_modified = moment().local().format('MM/DD/YYYY HH:mm:ss');
        data.s_modified_by = user.s_email;
        data.id = selectedItem.id;

        apiClient
            .post(
                `/updateStationsInfo`,
                {
                    data,
                })
            .then((response) => {
                setCorpStationsData(response.data);
                setModalEditStation(false);
                notify('Station Info Updated');
            })
            .catch((error) => {
            });
    };

    const handleCreateNewStation = () => {
        setModalTypeNew(true);
        setModalEditStation(true);
        setSelectedItemId(null);
    };

    const createCorpStation = (values) => {
        const data = values;
        data.t_created = moment().local().format('MM/DD/YYYY HH:mm:ss');
        data.s_created_by = user.s_email;
        data.t_modified = moment().local().format('MM/DD/YYYY HH:mm:ss');
        data.s_modified_by = user.s_email;

        apiClient
            .post(
                `/createCorpStation`,
                {
                    data,
                }
            )
            .then((response) => {
                setCorpStationsData(response.data);
                setModalEditStation(false);
                notify('Station Added');
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const deleteCorpStation = (s_unit) => {

        apiClient
            .delete(
                `/deleteCorpStation/${s_unit}`)
            .then((response) => {
                setCorpStationsData(response.data);
                setModalEditStation(false);
                notify('Station Deleted');
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const addCorpDockDoor = async () => {
        const { s_unit } = selectedItem;
        const data = {
            s_dock_door,
            s_unit,
        };

        const response = await apiClient.post(
            `/addCorpDockDoor`,
            {
                data,
            }
        );

        setDoors(response.data);
        set_s_dock_door('');
        notify('Door Added');
    };

    const removeCorpDockDoor = async (e, id) => {
        e.preventDefault();

        const data = {
            id,
        };

        const response = await apiClient.post(
            `/removeCorpDockDoor`,
            {
                data,
            }
        );

        setDoors(response.data);
        notify('Door Removed');
    };

    const addCalloutNotificationNumber = async (phoneNumber, unit) => {
        try {
            const res = await apiClient.post(`/callout-notification-number`, {
                unit,
                phoneNumber: phoneNumber.replace(/[(), -]/g, ''),
                createdBy: user.s_email,
                created: getTsDate()
            });
            setCalloutNotificationNumbers(prev => {
                const copy = _.cloneDeep(prev);
                copy.push(res.data);
                return copy;
            });
        } catch (err) {}
    }

    const deleteCalloutNotificationNumber = async (id) => {
        try {
            const res = await apiClient.delete(`/callout-notification-number/${id}`);
            setCalloutNotificationNumbers(prev => {
                const modified = prev.filter(item => item.id !== id);
                return modified;
            });
        } catch (err) {}
    }

    const addForklift = async (forklift, forkliftType, unit) => {
        try {
            const res = await apiClient.post(`/forklift`, {
                unit,
                name: forklift,
                type: forkliftType,
                createdBy: user.s_email,
                created: getTsDate()
            });
            setForklifts(prev => {
                const copy = _.cloneDeep(prev);
                copy.push(res.data);
                return copy;
            });
        } catch (err) {}
    }

    const deleteForklift = async (id) => {
        try {
            const res = await apiClient.delete(`/forklift/${id}`);
            setForklifts(prev => {
                const modified = prev.filter(item => item.id !== id);
                return modified;
            });
        } catch (err) {}
    }

    const launchUpdateWorkHours = (workDay) => {
        setWorkDay(workDay);
        setModalTimeSelection(true);
    }

    const updater = (_stationHours, stationId, day, openHours) => {
        const stationHours = [ ..._stationHours ];
        const index = stationHours.findIndex(item => item.stationId === stationId && item.day === day);
        if (index !== -1) {
            stationHours.splice(index, 1);
        }
        stationHours.push({
            stationId, 
            day, 
            openHours
        });
        return stationHours;
    }

    const updateWorkHours = async (stationId, day, openHours) => {
        if (!selectedItem) return;
        try {
            const res = await apiClient.post(`/updateStationWorkHours`, {
                stationId,
                day,
                openHours
            });
            setCorpStationsData(res.data);
            setModalTimeSelection(false);
            notify('Updated');
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <Fragment>
            <Row className="px-3 mb-2">
                <h4 style={{ display: 'inline' }}>Station Profiles</h4>
                <i
                    class="fas fa-plus-circle text-large hover-pointer text-primary ml-3"
                    onClick={() => handleCreateNewStation()}
                    data-tip={'Add Station'}
                ></i>
            </Row>
            <Row>
                <Col md={12}>
                    <ReactTable
                        data={corpStationsData}
                        mapping={mapping}
                        numRows={10}
                        handleClick={handleStationSelect}
                        index={true}
                    />
                </Col>
            </Row>
            <ModalEditStations
                open={modalEditStation}
                handleModal={setModalEditStation}
                item={selectedItem}
                setCorpStationsData={setCorpStationsData}
                updateStationsInfo={updateStationsInfo}
                createCorpStation={createCorpStation}
                modalTypeNew={modalTypeNew}
                deleteCorpStation={deleteCorpStation}
                doors={doors}
                s_dock_door={s_dock_door}
                set_s_dock_door={set_s_dock_door}
                addCorpDockDoor={addCorpDockDoor}
                removeCorpDockDoor={removeCorpDockDoor}
                calloutNotificationNumbers={calloutNotificationNumbers}
                addCalloutNotificationNumber={addCalloutNotificationNumber}
                deleteCalloutNotificationNumber={deleteCalloutNotificationNumber}
                forklifts={forklifts}
                addForklift={addForklift}
                deleteForklift={deleteForklift}
                stationHoursMap={stationHoursMap}
                launchUpdateWorkHours={launchUpdateWorkHours}
            />
            <ModalTimeSelection 
                modal={modalTimeSelection}
                setModal={setModalTimeSelection}
                station={selectedItem}
                workDay={workDay}
                existingHours={stationHoursMap[workDay]}
                updateWorkHours={updateWorkHours}
            />
        </Fragment>
    );
};

export default Stations;
